module.exports = __webpack_public_path__ + "static/media/silent_chat_off.8e8bec47.svg";